import { createApp } from 'vue/dist/vue.esm-bundler';
import News from './News.vue';


const mountEl = document.querySelector('[data-app-news-list]');

if ( mountEl )
{
    createApp(News, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}